import axiosInstance from '../axiosConfig';

const setupInterceptors = (setSessionExpiredMessage, navigate) => {
  axiosInstance.interceptors.response.use(
    response => response,
    async (error) => {
      const originalRequest = error.config;

      if (error.response && error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;

        // Falls die Anfrage bereits ein Retry hatte oder die Login-Route ist, kein Refresh versuchen
        if (originalRequest.url.includes('/auth/login') || originalRequest.url.includes('/auth/refresh')) {
          return Promise.reject(error);
        }

        try {
          const refreshResponse = await axiosInstance.get('/auth/refresh');
          const newAccessToken = refreshResponse.data.accessToken;
          localStorage.setItem('authToken', newAccessToken);
          // Setze Token als Bearer für Folgeanfragen
          axiosInstance.defaults.headers.common['Authorization'] = newAccessToken;
          originalRequest.headers['Authorization'] = newAccessToken;
          window.dispatchEvent(new Event('tokenRefreshed'));
          return axiosInstance(originalRequest);
        } catch (refreshError) {
          // Falls das Refresh-Token ebenfalls abgelaufen ist:
          localStorage.removeItem('authToken');
          delete axiosInstance.defaults.headers.common['Authorization'];
          setSessionExpiredMessage('Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.');
          navigate('/pages/login');
          return Promise.reject(refreshError);
        }
      }
      return Promise.reject(error);
    }
  );
};

export default setupInterceptors;